import type ApiUrlCreator from "@core-ui/ApiServices/ApiUrlCreator";
import FetchService from "@core-ui/ApiServices/FetchService";
import Method from "@core-ui/ApiServices/Types/Method";
import MimeTypes from "@core-ui/ApiServices/Types/MimeTypes";
import type { ChatAttachment } from "@ext/agent/core/attachmentStore";

export const fetchStoredAttachment = async (
	apiUrlCreator: ApiUrlCreator,
	sessionId: string,
	{ storagePath, mime }: Pick<ChatAttachment, "storagePath" | "mime">,
): Promise<Blob | null> => {
	const url = apiUrlCreator.getAgentSessionAttachmentUrl(sessionId, storagePath);
	const res = await FetchService.fetch(url, undefined, MimeTypes.text, Method.GET, false);
	if (!res.ok) return null;
	return new Blob([await res.arrayBuffer()], { type: mime });
};
